// Change this
const module = 'fixed-bookings'

import {checkAuth} from "@/services/auth";

// Change this
import Index from '@/views/fixed-bookings/Index'

let prefix = '/'

export default [
    {
        path: prefix+`${module}/edit/:id`,
        name: `${module}Index`,
        component: Index,
        beforeEnter (to,from,next){
            checkAuth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    }
                }

            )
        }
    },
]
